export default {
	"保存": '保存',
	"内部测试": '内部测试',
	"外部测试": '外部测试',
	'导出': '导出',
	'导入': '导入',
	'新建一页': '新建一页',
	'新建一题': '新建一题',
	"全部展开": '全部展开',
	"全部收起": '全部收起',
	"编辑": '编辑',
	"查看帮助": '查看帮助？',
	'确定': '确定',
	'关闭': '关闭',
	'取消': '取消',
	"修改": '修改',
	"提交": '提交',
	"下一页": '下一页',
	"关闭": '关闭',
	"点击上传":'点击上传',
	"新增":'新增',
	"新增列问题":'新增列问题',
	"新增行问题":'新增行问题',
	"新增选项":'新增选项',
	"题库":'题库',
	"选择分类":'选择分类',
	"新增问题":'新增问题',
	"是":'是',
	"否":'否',
	"长按开始语音作答":'长按开始语音作答',
	"下一题":'下一题',
  "清除":'清除',
  "点击签名":'点击签名',
  "新增分类":'新增分类',
  "下载模板":'下载模板'
}